<script setup>
const { locale } = useI18n()

const nuxtApp = useNuxtApp()

nuxtApp.hook("page:finish", () => {
		window.scrollTo(0, 0)
})

useHead({
	htmlAttrs: {
    lang: locale.value
  }
})
</script>

<template>
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>

<style>
.page-enter-active,
.page-leave-active {
  transition: all 0.2s;
}
.page-enter-from,
.page-leave-to {
  opacity: 0;
  filter: blur(1rem);
}
</style>